import React from "react";

import { CarCallSignsCellContent as Content } from "../components";

import base from "./base";

import { Column, ColumnId } from ".";

function carCallSigns({ width, onResize }: Column.Options) {
	return base(ColumnId.CarCallSigns, (item) => <Content item={item} />, {
		width,

		onResize: onResize as (
			columnWidth?: number | undefined,
			dataKey?: string | undefined,
		) => void,
	});
}

export default carCallSigns;
